import { legalVars, type LegalDoc, type LegalVars } from "./types";

/** 《用户服务协议》正文。改动要同步申报材料 docx(同一份文本导出)。 */
export function getTermsOfService(
  {
    company: LEGAL_COMPANY,
    product: LEGAL_PRODUCT,
    address: LEGAL_ADDRESS,
  }: LegalVars = legalVars()
): LegalDoc {
  return {
    title: `${LEGAL_PRODUCT}用户服务协议`,
    updatedAt: "2026年9月28日",
    intro: [
      `本协议是您（包括开通平台服务的企业“租户”及其授权使用平台的员工“用户”）与${LEGAL_COMPANY}（以下简称“我们”）之间就使用“${LEGAL_PRODUCT}”企业级AI应用平台（以下简称“平台”）所订立的协议。`,
      "请您在使用平台前仔细阅读本协议，特别是免除或限制责任、使用规范、争议解决等条款。您登录或继续使用平台，即表示您已阅读、理解并同意本协议及《隐私政策》。租户与我们另行签订书面合同的，书面合同与本协议不一致之处以书面合同为准。",
    ],
    sections: [
      {
        heading: "一、服务内容",
        blocks: [
          "平台以软件即服务（SaaS）方式，为企业提供基于人工智能的营销与经营服务，包括但不限于：AI经营顾问、海报/长图/短视频/数字人等内容生成、企业知识库、企业微信AI客服与导购、销售陪练、智能获客、AI官网等功能。租户可使用的功能范围以其开通的套餐或书面合同约定为准。",
          "我们会持续迭代平台功能，并可能对功能的名称、入口、交互方式进行调整。涉及租户已付费功能的实质性下线，我们将提前通知。",
        ],
      },
      {
        heading: "二、账号与安全",
        blocks: [
          {
            list: [
              "租户账号由我们为其开通；员工账号由租户管理员创建、分配权限及停用。租户应确保其员工遵守本协议，并对其员工账号下的行为负责。",
              "新账号首次登录须修改初始密码。您应妥善保管账号和密码，不得出借、转让或与他人共用账号。因您保管不善导致的损失由您自行承担。",
              "发现账号被盗用或存在安全隐患时，请立即联系租户管理员或我们处理。为保障安全，我们可能在账号异常时要求重新验证或临时限制登录。",
            ],
          },
        ],
      },
      {
        heading: "三、费用与积分",
        blocks: [
          {
            list: [
              "平台按AI用量计费，以“积分”作为结算单位。各功能的积分单价在功能页面或价目说明中公示，任务提交前平台会显示预估消耗。",
              "因平台或模型服务原因导致任务失败的，已扣除的积分将自动退回；因用户主动取消或提供的素材不符合要求导致的失败，按页面提示规则处理。",
              "积分的购买、续费及发票事宜以租户与我们签订的合同或订单为准，可联系您的客户经理办理。",
            ],
          },
        ],
      },
      {
        heading: "四、使用规范",
        blocks: [
          "您在使用平台（包括输入指令、上传素材、发布生成内容）时，应遵守法律法规和社会公德，不得利用平台制作、复制、发布、传播含有下列内容的信息，或从事下列行为：",
          {
            list: [
              "危害国家安全、荣誉和利益，煽动颠覆国家政权、破坏国家统一，宣扬恐怖主义、极端主义、民族仇恨、民族歧视的；",
              "含有暴力、淫秽色情、赌博、虚假有害信息，或违反公序良俗的；",
              "侵害他人名誉权、肖像权、隐私权、个人信息权益、知识产权等合法权益的，包括未经本人授权使用他人的人脸或声音制作数字人、复刻声音；",
              "发布违反《中华人民共和国广告法》等规定的虚假或引人误解的商业宣传，或冒充他人、伪造身份的；",
              "利用平台实施诈骗，或以深度合成内容误导公众的；",
              "未经授权批量抓取平台数据，攻击、干扰平台正常运行，或绕过平台的计费与安全措施的。",
            ],
          },
          "对违反上述规定的内容，我们有权依法采取拒绝生成、删除内容、限制功能、暂停或终止服务等措施，并保存有关记录，依法向主管部门报告。",
        ],
      },
      {
        heading: "五、生成内容说明",
        blocks: [
          {
            list: [
              "平台生成的文本、图片、音频、视频等内容由人工智能模型基于您的输入自动生成，可能存在不准确、不完整或与事实不符的情况。您应在使用和发布前自行审核，尤其是涉及价格、功效、资质、数据等事实性表述。平台生成内容不构成法律、财务、医疗等专业意见。",
              "您对外发布平台生成的内容时，应遵守《人工智能生成合成内容标识办法》及各发布平台的规则，按要求对AI生成内容进行标识，不得删除、篡改或隐匿平台依法添加的标识。",
              "AI客服等功能基于租户提供的知识库作答，租户应确保知识库内容真实、合法、及时更新；对于AI无法确定的问题，平台支持转交人工处理。",
            ],
          },
        ],
      },
      {
        heading: "六、知识产权",
        blocks: [
          {
            list: [
              "平台本身（包括软件、界面设计、模板、商标等）的知识产权归我们或相关权利人所有。未经许可，您不得复制、修改、反向工程或用于其他商业目的。",
              "您上传的资料、素材的权利归您或原权利人所有。您应确保对上传内容享有合法权利或已获得授权；因上传内容引发的侵权纠纷由您承担责任。",
              "在法律允许的范围内，您通过平台生成的内容，其相关权益归属于租户，租户可在其经营活动中使用。我们仅为提供和保障服务之目的在必要范围内使用上述内容。",
            ],
          },
        ],
      },
      {
        heading: "七、个人信息保护",
        blocks: [
          "我们按照《隐私政策》处理您的个人信息。租户通过平台处理其客户个人信息的，租户应确保已依法告知相关个人并取得必要的同意，我们作为受托方按照租户的指示处理。",
        ],
      },
      {
        heading: "八、服务的中断与终止",
        blocks: [
          {
            list: [
              "我们会尽合理努力保障平台稳定运行。因系统维护、升级需要中断服务的，我们会尽量选择业务低峰时段并提前告知。",
              "因不可抗力、基础网络或第三方服务（如云服务、模型服务、企业微信）故障等非我们所能控制的原因导致服务中断或受影响的，我们将积极协调恢复，但不承担由此产生的间接损失。",
              "租户可按合同约定终止服务。用户严重违反本协议的，我们有权暂停或终止向其提供服务。服务终止后，我们将按《隐私政策》处理相关数据。",
            ],
          },
        ],
      },
      {
        heading: "九、责任限制",
        blocks: [
          "在法律允许的最大范围内，我们对因使用平台而产生的任何间接、附带或衍生损失不承担责任；我们就本协议承担的赔偿总额不超过租户在引起责任事件前十二个月内向我们实际支付的服务费用。法律另有强制性规定的，从其规定。",
        ],
      },
      {
        heading: "十、协议的修改",
        blocks: [
          "我们可能根据法律法规变化和业务发展修订本协议，修订后的协议将在平台公布并以适当方式提示。您在协议修订后继续使用平台的，视为接受修订后的协议。",
        ],
      },
      {
        heading: "十一、法律适用与争议解决",
        blocks: [
          "本协议的订立、履行与解释适用中华人民共和国法律（不含港澳台地区法律）。因本协议产生的争议，双方应友好协商解决；协商不成的，任何一方均可向我们住所地有管辖权的人民法院提起诉讼。",
        ],
      },
      {
        heading: "十二、联系我们",
        blocks: [
          `如您对本协议有任何疑问，可通过平台内的售后服务群、您的客户经理，或书面致函与我们联系：${LEGAL_COMPANY}，地址：${LEGAL_ADDRESS}。`,
        ],
      },
    ],
  };
}
